<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <table id="loanTermTabTable" class="table table-sm">
          <tbody>
            <tr>
              <td style="width:200px"><strong>Loan Status</strong></td>
              <td>Missed Repayments</td>
            </tr>
            <tr>
              <td><strong>Loan Application ID</strong></td>
              <td>{{ loanTerms.loan_number }}</td>
            </tr>
            <tr>
              <td><strong>Loan Product</strong></td>
              <td>{{ loanTerms.loan_product_name }}</td>
            </tr>
            <tr>
              <td colspan="2" class="bg-navy disabled color-palette"><strong>Loan Terms</strong></td>
            </tr>
            <tr>
              <td><strong>Disbursed By</strong></td>
              <td>{{ loanTerms.disbursed_by }}</td>
            </tr>
            <tr>
              <td><strong>Principal Amount</strong></td>
              <td>₱{{ formatNumber(loanTerms.principal_amount) }}</td>
            </tr>
            <tr>
              <td><strong>Loan Release Date</strong></td>
              <td>{{ formatDate(loanTerms.loan_released_date) }}</td>
            </tr>
            <tr>
              <td><strong>Loan Interest Method</strong></td>
              <td>{{ loanTerms.interest_method }}</td>
            </tr>
            <tr>
              <td><strong>Loan Interest</strong></td>
              <td>{{ loanTerms.default_loan_interest }}%/{{ loanTerms.loan_interest_period }}</td>
            </tr>
            <tr>
              <td><strong>Loan Duration</strong></td>
              <td>{{ loanTerms.maximum_loan_duration }}</td>
            </tr>
            <tr>
              <td><strong>Repayment Cycle</strong></td>
              <td>{{ loanTerms.repayment_cycle }}</td>
            </tr>
            <tr>
              <td><strong>Number of Repayments</strong></td>
              <td>{{ loanTerms.maximum_repayments }}</td>
            </tr>
            <tr>
              <td><strong>Interest Start Date</strong></td>
              <td>{{ formatDate(loanTerms.interest_start_date) }}</td>
            </tr>
            <tr>
              <td colspan="2" class="bg-navy disabled color-palette"><strong>Loan Fees</strong></td>
            </tr>
            <tr v-for="(feeName, index) in loanTerms.fees.fee_names" :key="index" v-if="feeName !== 'None'">
              <td><strong>{{ feeName }}:</strong></td>
              <td>{{ loanTerms.fees.fee_amounts[index] }}</td>
            </tr>
            <tr>
              <td colspan="2" class="bg-navy disabled color-palette"><strong>Loan Status History</strong></td>
            </tr>
            <tr>
              <td><strong>Open:</strong></td>
              <td>{{ formatDate(loanTerms.interest_start_date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'loan-terms',
  data() {
    return {
      loanTerms: {
        fees: {
          fee_names: [],
          fee_amounts: []
        }
      }
    };
  },

  computed: {
    loanID() {
      return this.$route.params.id;
    },
    borrowerID() {
      return this.$route.params.bid;
    }
  },

  methods: {
    fetchLoanTerms() {
      axios.get('api/loanTerm/' + this.loanID + '/' + this.borrowerID, {
        headers: { 'Content-Type': 'application/json' }
       }).then(response => {
          this.loanTerms = response.data;
        })
        .catch(error => {
          console.error('Failed to fetch loan terms:', error);
        });
    },
    formatNumber(num) {
      if (!num) return '0';
      return parseFloat(num).toLocaleString();
    },
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    }
  },
  created() {
    this.fetchLoanTerms();
  }
};
</script>
